import React from "react";
import { string } from "prop-types";

const propTypes = { id: string };

export const Svg = (props) => {
  const { id } = props;
  switch (id) {
    case "timeframeid":
      return (
        <svg
          width="18"
          height="19"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          focusable="false"
          aria-hidden="true"
        >
          <g fill="none" fillRule="evenodd">
            <path d="M15.167 7.2H2.833c-.372 0-.673.265-.673.591v8.179c0 .326.301.59.673.59h12.334c.372 0 .673-.264.673-.59V7.79c0-.326-.301-.591-.673-.591zm-8.565 8.245H3.34v-3.24h3.263v3.24zm0-3.984H3.34v-3.24h3.263v3.24zm4.108 3.984H7.447v-3.24h3.263v3.24zm0-3.984H7.447v-3.24h3.263v3.24zm4.261 3.984h-3.263v-3.24h3.263v3.24zm0-3.984h-3.263v-3.24h3.263v3.24z" />
            <path
              d="M16.302 2.16h-.594v1.077c0 .72-.584 1.305-1.302 1.305a1.305 1.305 0 01-1.302-1.305V2.16H4.896v1.077c0 .72-.584 1.305-1.302 1.305a1.305 1.305 0 01-1.302-1.305V2.16h-.594A1.7 1.7 0 000 3.861V17.02a1.7 1.7 0 001.698 1.701h14.604A1.7 1.7 0 0018 17.019V3.86a1.7 1.7 0 00-1.698-1.701zm-.397 13.903c0 .34-.304.615-.68.615H2.775c-.375 0-.68-.275-.68-.615V7.54c0-.34.305-.616.68-.616h12.452c.376 0 .68.276.68.616v8.523z"
              fill="currentColor"
              fillRule="nonzero"
            />
            <path
              d="M3.6 3.6c.397 0 .72-.261.72-.582V.582C4.32.261 3.997 0 3.6 0c-.397 0-.72.26-.72.582v2.436c0 .32.323.582.72.582zM14.4 3.6c.397 0 .72-.261.72-.582V.582c0-.321-.323-.582-.72-.582-.397 0-.72.26-.72.582v2.436c0 .32.323.582.72.582zM2.88 7.92h3.6v3.6h-3.6zM7.2 7.92h3.6v3.6H7.2zM2.88 12.24h3.6v3.6h-3.6zM7.2 12.24h3.6v3.6H7.2zM11.52 7.92h3.6v3.6h-3.6zM11.52 12.24h3.6v3.6h-3.6z"
              fill="currentColor"
              fillRule="nonzero"
            />
          </g>
        </svg>
      );
    case "locationid":
      return (
        <svg
          width="12"
          height="17"
          viewBox="0 0 12 17"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          focusable="false"
          aria-hidden="true"
        >
          <path
            d="M6 0c3.3134 0 6 2.6929 6 6.0141s-3.582 7.6747-5.6866 10.7267c-.1343.2244-.4477.2244-.6268 0C3.6269 13.6888 0 9.3353 0 6.014 0 2.693 2.6866 0 6 0zm0 3.1417c1.612 0 2.9104 1.3016 2.9104 2.8724C8.9104 7.6298 7.612 8.9314 6 8.9314c-1.5672 0-2.8657-1.3016-2.8657-2.9173 0-1.5708 1.2985-2.8724 2.8657-2.8724z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </svg>
      );
    case "chev-down":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-chevron-down"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      );
    default:
      return (
        <svg
          width="12"
          height="17"
          viewBox="0 0 12 17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 0c3.3134 0 6 2.6929 6 6.0141s-3.582 7.6747-5.6866 10.7267c-.1343.2244-.4477.2244-.6268 0C3.6269 13.6888 0 9.3353 0 6.014 0 2.693 2.6866 0 6 0zm0 3.1417c1.612 0 2.9104 1.3016 2.9104 2.8724C8.9104 7.6298 7.612 8.9314 6 8.9314c-1.5672 0-2.8657-1.3016-2.8657-2.9173 0-1.5708 1.2985-2.8724 2.8657-2.8724z"
            fill="currentColor"
            fillRule="evenodd"
            role="img"
            focusable="false"
            aria-hidden="true"
          />
        </svg>
      );
  }
};

Svg.propTypes = propTypes;
export default Svg;
